import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const homeFor = (role) =>
  role === "admin" ? "/admin" : role === "client" ? "/client" : "/team";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (user === undefined)
    return (
      <div className="min-h-screen grid place-items-center text-amber-400 font-display uppercase tracking-widest">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) {
    return pathname === "/change-password" ? children : <Navigate to="/change-password" replace />;
  }
  if (user.mfa_setup_required) {
    return pathname === "/security" ? children : <Navigate to="/security" replace />;
  }
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}
